import { useFormikContext } from 'formik';
import React, { useState, useEffect } from 'react';

import { ReactComponent as BankSlim } from '../../../../assets/icons/BankSlim.svg';
import CardBankPayout from '../../../CardBankPayout/CardBankPayout';
import CardArrow from '../../../Cards/CardArrow/CardArrow';
import Radio from '../../../inputs/Radios/Radio/Radio';

import classes from './CardBankAccountPay.module.scss';

const CardBankAccountPay = ({ open, totalValueToPay, sourceAccountsToPay, setShowMethodPay, druoAccounts = [], defaultDruoAccountId }) => {
  const { setFieldValue } = useFormikContext();

  const [accountSelectedRadio, setAccountSelectedRadio] = useState();
  const [hasInitialized, setHasInitialized] = useState(false);

  // Pre-seleccionar la cuenta predeterminada cuando se abra el componente y haya cuentas disponibles
  useEffect(() => {
    // Validaciones defensivas para evitar errores
    if (!open || hasInitialized || !Array.isArray(druoAccounts) || druoAccounts.length === 0) {
      return;
    }

    // Buscar la cuenta predeterminada, si no existe usar la primera cuenta disponible
    let accountToSelect = defaultDruoAccountId
      ? druoAccounts.find(account => account.druoAccountId === defaultDruoAccountId)
      : null;

    // Si no se encontró la cuenta predeterminada, usar la primera
    if (!accountToSelect) {
      accountToSelect = druoAccounts[0];
    }

    if (!accountToSelect?.druoAccountId) {
      return;
    }

    const { druoAccountId, bankId, subtypeLabel, bankLast4Digits, owner, identificationTypeLabel, identificationNumber } = accountToSelect;

    setAccountSelectedRadio(druoAccountId);
    setFieldValue('sourceAccountsToPay', [
      {
        value: totalValueToPay,
        druoAccountId,
        bankId,
        subtypeLabel,
        bankLast4Digits,
        name: owner,
        identification: `${identificationTypeLabel || ''} ${identificationNumber || ''}`
      }
    ]);
    setHasInitialized(true);
  }, [open, druoAccounts, defaultDruoAccountId, hasInitialized, totalValueToPay, setFieldValue]);

  const handlerRadio = value => {
    const account = druoAccounts.find(account => account.druoAccountId === value);
    if (account) {
      const { bankId, subtypeLabel, bankLast4Digits, owner, identificationTypeLabel, identificationNumber } = account;
      setFieldValue('sourceAccountsToPay', [
        {
          value: totalValueToPay,
          druoAccountId: value,
          bankId,
          subtypeLabel,
          bankLast4Digits,
          name: owner,
          identification: `${identificationTypeLabel || ''} ${identificationNumber || ''}`
        }
      ]);
      setAccountSelectedRadio(value);
    }
  };

  const setShow = () => {
    setFieldValue('sourceAccountsToPay', []);
    setAccountSelectedRadio();
    setHasInitialized(false);
    setShowMethodPay('bankAccount');
  };

  return (
    <CardArrow
      name='bankAccount'
      Icon={BankSlim}
      title='Cuentas de banco'
      description='Selecciona tu cuenta de pago'
      open={open}
      onClick={setShow}>
      {druoAccounts.length === 0 ? (
        <div className={classes.empty}>
          <span className={`medium-16 ${classes.text}`}>
            Dirigete a configuracion e inscribe tu cuenta bancaria en conexiones.
          </span>
        </div>
      ) : (
        <div className={classes.card}>
          <div>
            <span className='semibold-16'>Selecciona la cuenta desde la que quieres pagar</span>
            <div>
              {druoAccounts.map((druoBank, idx) => (
                <div key={druoBank.druoAccountId} className={classes['radio-option']}>
                  <Radio
                    key={druoBank.druoAccountId}
                    name={`radio-${idx}`}
                    id={druoBank.druoAccountId}
                    value={accountSelectedRadio}
                    onChange={handlerRadio}
                  />
                  <CardBankPayout
                    bankId={druoBank.bankId}
                    subtypeLabel={druoBank.subtypeLabel}
                    bankLast4Digits={druoBank.bankLast4Digits}
                    name={druoBank.owner}
                    identification={`${druoBank.identificationTypeLabel || ''} ${druoBank.identificationNumber || ''}`}
                    isDefault={druoBank.druoAccountId === defaultDruoAccountId}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </CardArrow>
  );
};

export default CardBankAccountPay;
